<template>
  <v-container fluid class="mb-10">
    <v-form v-model="valid">
      <v-row v-if="!langchain_settings">
        <v-col> Please the langchain Config </v-col>
      </v-row>
      <v-row v-else>
        <v-col cols="12">
          <v-card class="mx-auto" tile elevation="1" outlined>
            <v-card-title>Config: service client</v-card-title>
            <v-card-text>
              <v-row no-gutters justify="center" align="center">
                <v-col cols="12">
                  <v-row dense justify="start" align="center">
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="cache_number"
                        label="(*) number of cache messages"
                        placeholder="number"
                        type="number"
                        :rules="form_roles.number"
                        outlined
                        required
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="utc_offset"
                        label="(*) UTC Offset"
                        placeholder="number"
                        type="number"
                        :rules="form_roles.number"
                        outlined
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="text-center">
                      RAG is used for Client Service:
                      <span
                        :class="[
                          'title-3',
                          `${!is_use_context ? 'red--text' : 'green--text'}`,
                        ]"
                      >
                        {{ is_use_context ? "Yes" : "No" }}
                      </span>
                    </v-col>
                    <v-col cols="12" md="6" class="text-center">
                      Product RAG is used for product recommandation:
                      <span
                        :class="[
                          'title-3',
                          `${!is_product ? 'red--text' : 'green--text'}`,
                        ]"
                      >
                        {{ is_product ? "Yes" : "No" }}
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card class="mx-auto" tile elevation="1" outlined>
            <v-card-title>Config: index param</v-card-title>
            <v-card-text>
              <v-row no-gutters justify="center" align="center">
                <v-col cols="12">
                  <v-row dense justify="start" align="center">
                    <v-col cols="12" md="6">
                      <v-text-field
                        :value="
                          langchain_settings.index_param.product_collection_name
                        "
                        label="Collection Name for product recommandation"
                        type="text"
                        outlined
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        :value="
                          langchain_settings.index_param
                            .client_service_collection_name
                        "
                        label="Collection Name for client service"
                        type="text"
                        outlined
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        :value="langchain_settings.index_param.product_db_name"
                        label="Product DB Name"
                        type="text"
                        outlined
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        :value="
                          langchain_settings.index_param.service_client_db_name
                        "
                        label="Service Client DB Name"
                        type="text"
                        outlined
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12">
          <v-card
            class="mx-auto"
            tile
            elevation="1"
            outlined
            :loading="geAi_loading"
          >
            <v-card-title
              style="
                margin-top: 10px;
                font-family: Arial, Helvetica, sans-serif;
              "
              >Playground</v-card-title
            >
            <v-divider
              class="my-4"
              style="height: 2px; background-color: black"
            ></v-divider>

            <v-card-text
              id="genai_chat"
              class="message-content pl-6 pr-6 white"
            >
              <v-row class="fill-height pb-14" align="end">
                <v-col>
                  <div
                    v-for="(item, index) in messages"
                    :key="index"
                    :class="[
                      'd-flex flex-row align-center my-2',
                      item.type == 'user' ? 'justify-end' : 'justify-start',
                    ]"
                  >
                    <span
                      v-if="item.type == 'user'"
                      class="grey-darken--text mr-3 text-content user"
                      v-html="convertMarkdown(item.content)"
                    ></span>
                    <v-avatar
                      :color="item.type == 'user' ? 'indigo' : 'red'"
                      size="36"
                      class="align-self-start"
                    >
                      <span class="white--text text-button">{{
                        item.type.slice(0, 2)
                      }}</span>
                    </v-avatar>
                    <span
                      v-if="item.type != 'user'"
                      class="#8f8f8f--text ml-3 text-content ai"
                      v-html="convertMarkdown(item.content)"
                    ></span>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row no-gutters justify="center">
                <v-col cols="6">
                  <div class="d-flex flex-row align-center">
                    <v-text-field
                      :loading="geAi_loading"
                      hide-details
                      outlined
                      v-model="msg"
                      :rules="form_roles.text"
                      placeholder="Please enter your message"
                    ></v-text-field>
                    <v-btn
                      color="success"
                      elevation="1"
                      :disabled="!valid"
                      :dark="valid"
                      icon
                      large
                      outlined
                      class="ml-4"
                      @click="send"
                    >
                      <v-icon class="ml-1">mdi-send</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import utils from "@/utils";

export default {
  name: "llmPlayground",
  components: {},
  data: () => ({
    valid: false,
    geAi_loading: false,
    loading: true,
    messages: [],
    cache_number: 0,
    utc_offset: 0,
    form_roles: {
      text: [
        (value) => {
          if (value && value.trim()) return true;
          return "field is required.";
        },
      ],
      number: [
        (value) => {
          if (/^\d+$/.test(value)) return true;
          return "field is required. and Must be a number";
        },
      ],
    },
    msg: null,
  }),
  computed: {
    langchain_settings() {
      const data = this.$store.state.llm_config?.config?.langchain_settings;
      console.log("langchain_settings", data);
      return data;
    },
    is_use_context() {
      return this.langchain_settings?.is_use_context || false;
    },
    is_product() {
      return this.langchain_settings?.is_product || false;
    },
  },
  mounted() {
    setTimeout(() => {
      this.scrollDown();
    }, 100);
  },
  async created() {
    try {
      this.loading = true;
      await this.$store.dispatch("FETCH_LLM_CONFIG");
      this.cache_number = this.$store.state.llm_config?.config?.question_counter;
      this.utc_offset = this.langchain_settings.utc_offset;
      this.loading = false;
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    async send() {
      try {
        this.geAi_loading = true;
        let messages_history = [];
        if (!this.cache_number) {
          this.$toast.error(
            "Please set the cache number must be greater than 0"
          );
          return;
        }
        if (this.messages?.length) {
          messages_history = this.messages.slice(this.cache_number * -1);
        }

        messages_history.push({
          type: "user",
          content: this.msg,
        });

        this.messages.push({
          type: "user",
          content: this.msg,
        });

        setTimeout(() => {
          this.scrollDown();
        }, 100);

        await this.$store
          .dispatch("GENAI_PLAYGROUND_INVOKE", {
            utc_offset: Number(this.utc_offset),
            messages_history: messages_history,
          })
          .then((response) => {
            console.log(response);
            this.msg = null;
            this.geAi_loading = false;
            this.messages.push({ ...response, type: "ai" });

            setTimeout(() => {
              this.scrollDown();
            }, 100);
          })
          .catch((e) => {
            console.log(e);
            this.$toast.error("Error while sending the message");
            this.geAi_loading = false;
          });
      } catch (e) {
        console.log(e);
      }
    },
    scrollDown() {
      const iframe = document.getElementById("genai_chat");
      if (iframe) {
        iframe.scrollTo({
          top: iframe.scrollHeight,
          behavior: "smooth",
        });
      }
    },
    convertMarkdown(text) {
      text = utils.convertMardownToHTML(text);
      return text;
    },
  },
};
</script>

<style scoped>
.message-content {
  height: calc(100vh - 400px);
  overflow-y: auto;
  background: #eeeeee;
  padding: 16px;
}

.text-content {
  max-width: 50%;
  word-wrap: break-word;
  padding: 12px;
  border-radius: 12px;
}

.text-content.user {
  background-color: #408fec;
  color: white;
  margin-left: auto;
  text-align: right;
}

.text-content.ai {
  background-color: #f1f1f1;
  color: black;
  margin-right: auto;
  text-align: left;
}

.d-flex {
  display: flex;
}

.align-center {
  align-items: center;
}

.justify-end {
  justify-content: flex-end;
}

.justify-start {
  justify-content: flex-start;
}
</style>
